// i18n area 'auth' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.el-GR.meta.json.
import type { enUS } from './auth'

export const elGR: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Συνδεθείτε στον λογαριασμό σας',
    username: 'Όνομα χρήστη',
    usernamePlaceholder: 'Εισαγάγετε το όνομα χρήστη',
    usernameHint: 'Χρησιμοποιήστε χρήστης@τομέας για έλεγχο ταυτότητας σε realm υπηρεσίας καταλόγου',
    continue: 'Συνέχεια',
    changeUser: 'Δεν είστε εσείς;',
    password: 'Κωδικός πρόσβασης',
    forgotPassword: 'Ξεχάσατε τον κωδικό πρόσβασης;',
    submit: 'Σύνδεση',
    otp: 'Κωδικός μίας χρήσης',
    otpSubtitle: 'Εισαγάγετε τον κωδικό της εφαρμογής ελέγχου ταυτότητας',
    otpHint: 'Έξι ψηφία από την εφαρμογή ελέγχου ταυτότητας, ή ένας από τους κωδικούς ανάκτησης',
    otpSubmit: 'Επαλήθευση',
    invalidCredentials: 'Μη έγκυρο όνομα χρήστη ή κωδικός πρόσβασης',
    tooManyAttempts: 'Πάρα πολλές προσπάθειες — περιμένετε λίγο και δοκιμάστε ξανά',
    realmUnavailable: 'Το realm δεν μπορεί να επαληθεύσει τα διαπιστευτήρια αυτήν τη στιγμή — η αποθήκη της συστοιχίας δεν είναι προσβάσιμη. Συνδεθείτε ως τοπικός χρήστης (break-glass).',
    genericError: 'Η σύνδεση απέτυχε — είναι προσβάσιμο το backend του TVirt;'
  },
  user: {
    logout: 'Αποσύνδεση',
    password: {
      menu: 'Αλλαγή κωδικού πρόσβασης',
      title: 'Αλλάξτε τον κωδικό πρόσβασής σας',
      current: 'Τρέχων κωδικός πρόσβασης',
      new: 'Νέος κωδικός πρόσβασης',
      confirm: 'Επιβεβαίωση νέου κωδικού πρόσβασης',
      mismatch: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
      error: 'Δεν ήταν δυνατή η αλλαγή του κωδικού πρόσβασης',
      forcedTitle: 'Αλλάξτε τον κωδικό πρόσβασης για να συνεχίσετε',
      forcedHint: 'Αυτός ο κωδικός πρόσβασης ορίστηκε από διαχειριστή και πρέπει να αντικατασταθεί πριν από την είσοδο.',
      forcedSubmit: 'Αλλαγή και είσοδος'
    },
    mfa: {
      title: 'Έλεγχος ταυτότητας δύο παραγόντων',
      subtitle: 'Ένας δεύτερος παράγοντας που ζητείται σε κάθε σύνδεση',
      loadError: 'Δεν ήταν δυνατή η φόρτωση της κατάστασης του δεύτερου παράγοντα',
      enrolled: 'Ενεργός',
      notEnrolled: 'Ανενεργός',
      enrolledAt: 'Ενεργοποιήθηκε στις',
      codesRemaining: 'Κωδικοί ανάκτησης που απομένουν',
      requiredHint:
        'Ένας διαχειριστής απαιτεί δεύτερο παράγοντα σε αυτόν τον λογαριασμό: ρυθμίστε τον τώρα — μέχρι να το κάνετε μπορείτε να συνδέεστε, αλλά όχι πολλά περισσότερα.',
      enroll: 'Ρύθμιση',
      enrollTitle: 'Ρύθμιση ελέγχου ταυτότητας δύο παραγόντων',
      enrollHint: 'Σαρώστε αυτόν τον κωδικό με την εφαρμογή ελέγχου ταυτότητας, έπειτα πληκτρολογήστε τον κωδικό που εμφανίζει για επιβεβαίωση.',
      secretHint: 'Δεν μπορείτε να τον σαρώσετε; Πληκτρολογήστε αυτό το μυστικό στην εφαρμογή:',
      code: 'Κωδικός από την εφαρμογή',
      confirm: 'Επιβεβαίωση',
      startError: 'Δεν ήταν δυνατή η έναρξη της ρύθμισης',
      confirmError: 'Δεν ήταν δυνατή η επιβεβαίωση της ρύθμισης',
      codesTitle: 'Οι κωδικοί ανάκτησής σας',
      codesWarning:
        'Αυτοί οι κωδικοί εμφανίζονται μία φορά μόνο. Αποθηκεύστε τους τώρα: καθένας σάς συνδέει όταν η εφαρμογή ελέγχου ταυτότητας δεν είναι διαθέσιμη, και ισχύει μία φορά μόνο.',
      codesAck: 'Έχω αποθηκεύσει τους κωδικούς ανάκτησης',
      codesDone: 'Τέλος',
      copy: 'Αντιγραφή',
      copied: 'Αντιγράφηκε',
      download: 'Λήψη',
      regenerate: 'Νέοι κωδικοί ανάκτησης',
      regenerateTitle: 'Αναδημιουργία των κωδικών ανάκτησης',
      regenerateHint: 'Όλοι οι κωδικοί που έχουν εκδοθεί μέχρι τώρα παύουν να λειτουργούν τη στιγμή που δημιουργείται το νέο σύνολο.',
      regenerateConfirm: 'Αναδημιουργία',
      regenerateError: 'Δεν ήταν δυνατή η αναδημιουργία των κωδικών ανάκτησης',
      remove: 'Αφαίρεση',
      removeTitle: 'Αφαίρεση του δεύτερου παράγοντα',
      removeConfirm: 'Αφαίρεση',
      removeHint: 'Ο λογαριασμός επιστρέφει μόνο στον κωδικό πρόσβασης. Μπορείτε να ρυθμίσετε ξανά έναν δεύτερο παράγοντα όποτε θέλετε.',
      removeRequiredHint:
        'Ένας διαχειριστής απαιτεί δεύτερο παράγοντα σε αυτόν τον λογαριασμό, οπότε ο διακομιστής θα αρνηθεί την αφαίρεση — ζητήστε του πρώτα να άρει την απαίτηση.',
      removeError: 'Δεν ήταν δυνατή η αφαίρεση του δεύτερου παράγοντα'
    },
    profile: {
      menu: 'Μετάβαση στο προφίλ μου',
      sessions: 'Ενεργές συνεδρίες',
      sessionsHint: 'Οι ανοιχτές συνεδρίες σας σε αυτόν τον κόμβο',
      sessionsEmpty: 'Καμία ενεργή συνεδρία',
      sessionCreated: 'Συνδέθηκε',
      sessionExpires: 'Λήγει',
      revoke: 'Ανάκληση συνεδρίας',
      revokeError: 'Δεν ήταν δυνατή η ανάκληση της συνεδρίας',
      loadError: 'Δεν ήταν δυνατή η φόρτωση των συνεδριών'
    }
  }
}
